






















































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { storeLaundrySupervisi } from "@/store/modules/LaundrySupervisiStore";
import LaundrySupervisiSvc from "@/services/LaundrySupervisiService";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import LaundrySeksiChecklist from "./LaundrySeksiChecklist.vue";

@Component({
  components: { LaundrySeksiChecklist }
})
export default class LaundrySupervisiDetail extends Vue {
  @Prop({ required: true }) sessionData!: any;

  storeModule = storeLaundrySupervisi;
  session: any = null;
  loading = false;
  showAckDialog = false;
  ackPassword = "";
  acknowledging = false;

  seksiList = [
    { seksi: "alur", label: "I. Supervisi Alur" },
    { seksi: "fasilitas_kebersihan", label: "II. Supervisi Fasilitas dan Kebersihan" },
    { seksi: "proses", label: "III. Supervisi Proses" },
  ];

  async mounted() {
    this.loading = true;
    await this.storeModule.loadDetail(this.sessionData.id);
    this.session = this.storeModule.currentSession;
    this.loading = false;
  }

  get scoreColor() {
    if (!this.session) return "";
    const s = this.session.compliance_score;
    if (s >= 80) return "green--text";
    if (s >= 60) return "orange--text";
    return "red--text";
  }

  /** Sesi lama masih menyimpan jawaban ya/tidak — skor legacy tetap dirender. */
  get hasLegacyHasil(): boolean {
    if (!this.session?.items) return false;
    return this.session.items.some(
      (i: any) => i.hasil !== null && i.hasil !== undefined && i.hasil !== ""
    );
  }

  getItemsBySeksi(seksi: string) {
    if (!this.session?.items) return [];
    return this.session.items
      .filter((i: any) => i.definition?.seksi === seksi)
      .sort((a: any, b: any) => (a.definition?.urutan || 0) - (b.definition?.urutan || 0))
      .map((i: any) => ({
        definition_id: i.definition_id,
        kode_item: i.definition?.kode_item,
        seksi: i.definition?.seksi,
        urutan: i.definition?.urutan,
        komponen_supervisi: i.definition?.komponen_supervisi,
        tipe_jawaban: i.definition?.tipe_jawaban,
        nilai_target_min: i.definition?.nilai_target_min,
        nilai_target_max: i.definition?.nilai_target_max,
        kritikal: i.definition?.kritikal,
        display_no: this.getDisplayNo(i.definition),
        hasil: i.hasil,
        nilai_numeric: i.nilai_numeric,
        masalah: i.masalah || "",
        rekomendasi: i.rekomendasi || "",
        foto_bukti: i.foto_bukti || [],
      }));
  }

  getDisplayNo(def: any) {
    if (!def) return "";
    const kode = def.kode_item || "";
    const parts = kode.split("-");
    return parts[parts.length - 1] || "";
  }

  formatDate(d: string) {
    return d ? moment(d).format("DD MMMM YYYY") : "-";
  }

  formatDateTime(dt: string) {
    return dt ? moment(dt).format("DD-MM-YYYY HH:mm") : "-";
  }

  printPdf() {
    if (this.session?.id) {
      LaundrySupervisiSvc.printPdf(this.session.id);
    }
  }

  async doAcknowledge() {
    if (!this.ackPassword) {
      appModule.NoticeDelay("Password wajib diisi");
      return;
    }
    this.acknowledging = true;
    try {
      const resp = await LaundrySupervisiSvc.acknowledge(this.session.id, {
        password: this.ackPassword,
      });
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil acknowledge supervisi");
        this.showAckDialog = false;
        this.ackPassword = "";
        this.$emit("saved");
        this.$emit("back");
      }
    } catch {
      // handled by ErrorAlert
    }
    this.acknowledging = false;
  }
}
